exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --primary: #013188;\n  --primary-darker: #002d72;\n  --secondary: #ff720a;\n  --secondary-darker: #dd5f13;\n  --button-text: #fefefe;\n  --disabled: #c2c2c2;\n  --button-text-disabled: rgba(0,0,0,0.38);\n  --bg-auth: url(" + require("assets/imgs/login/bg.jpg") + ");\n  --logo-auth: none;\n  --logo-header: none;\n  --favicon: none;\n}\nmain .closeDrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  background: transparent;\n  z-index: 10;\n  display: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/app.component.styl
// module id = ../../../../../src/app/app.component.styl
// module chunks = main